import { Component, OnInit } from '@angular/core';
import { WesternUnion } from './western-union';
import { ModalContainerService, ModalService, UserService, BaseModalContainer } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-western-union',
  templateUrl: './western-union.component.html'  
})
export class WesternUnionComponent
extends BaseModalContainer<WesternUnion>
implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<WesternUnion>,
    protected activatedRoute: ActivatedRoute,
    protected modalService: ModalService,
    protected userService: UserService
  ) { 
    super(modalContainerService, activatedRoute, modalService, userService);
  } 

  ngOnInit() {
  }

}
